import axios from 'axios';

export default class PosService {
    /**
     * Get a pos.
     *
     * @param {String} token
     * @return {AxiosPromise<any>}
     */
    static get(token) {
        return axios.get(this.endpoint() + '/' + token);
    }

    /**
     * Get endpoint of API.
     *
     * @return {string}
     */
    static endpoint() {
        return 'points-of-sale';
    }
}
